import React from 'react';
import PnmacMeta from './Platform/PnmacMeta';
export default PnmacMeta;